// Session lifecycle
export const TWILIO_SESSION_CONTEXT = "TWILIO_SESSION_CONTEXT";

// Room state
export const TWILIO_ROOM_CONNECTING = "TWILIO_ROOM_CONNECTING";
export const TWILIO_ROOM_CONNECTED = "TWILIO_ROOM_CONNECTED";
export const TWILIO_ROOM_DISCONNECTED = "TWILIO_ROOM_DISCONNECTED";
export const TWILIO_ROOM_RECONNECTING = "TWILIO_ROOM_RECONNECTING";
export const TWILIO_ROOM_RECONNECTED = "TWILIO_ROOM_RECONNECTED";
export const TWILIO_ROOM_CONNECT_FAILED = "TWILIO_ROOM_CONNECT_FAILED";

// Participants
export const TWILIO_PARTICIPANT_CONNECTED = "TWILIO_PARTICIPANT_CONNECTED";
export const TWILIO_PARTICIPANT_DISCONNECTED =
  "TWILIO_PARTICIPANT_DISCONNECTED";

// Track lifecycle
export const TWILIO_TRACK_PUBLISHED = "TWILIO_TRACK_PUBLISHED";
export const TWILIO_TRACK_UNPUBLISHED = "TWILIO_TRACK_UNPUBLISHED";
export const TWILIO_TRACK_SUBSCRIBED = "TWILIO_TRACK_SUBSCRIBED";
export const TWILIO_TRACK_UNSUBSCRIBED = "TWILIO_TRACK_UNSUBSCRIBED";
export const TWILIO_TRACK_ENABLED = "TWILIO_TRACK_ENABLED";
export const TWILIO_TRACK_DISABLED = "TWILIO_TRACK_DISABLED";
export const TWILIO_TRACK_SWITCHED_OFF = "TWILIO_TRACK_SWITCHED_OFF";
export const TWILIO_TRACK_SWITCHED_ON = "TWILIO_TRACK_SWITCHED_ON";
export const TWILIO_TRACK_PUBLICATION_FAILED =
  "TWILIO_TRACK_PUBLICATION_FAILED";
// SQ-455 diagnostics: snapshot of a participant's tracks at the moment we
// start handling it, and a marker for each track that was already subscribed
// before our trackSubscribed listener ran (i.e. the race the fix closes).
export const TWILIO_PARTICIPANT_TRACKS_AT_HANDLE =
  "TWILIO_PARTICIPANT_TRACKS_AT_HANDLE";
export const TWILIO_TRACK_PRESUBSCRIBED_ATTACHED =
  "TWILIO_TRACK_PRESUBSCRIBED_ATTACHED";
// SQ-455 diagnostics: fired when a remote track first produces media
// ("started"), carrying ms since room connect — i.e. the real duration of the
// remote-media blackout the patient experiences while P2P ICE establishes.
export const TWILIO_REMOTE_TRACK_STARTED = "TWILIO_REMOTE_TRACK_STARTED";

// Local device / permissions
export const TWILIO_LOCAL_PERMISSIONS_REQUESTED =
  "TWILIO_LOCAL_PERMISSIONS_REQUESTED";
export const TWILIO_LOCAL_PERMISSIONS_GRANTED =
  "TWILIO_LOCAL_PERMISSIONS_GRANTED";
export const TWILIO_LOCAL_PERMISSIONS_DENIED =
  "TWILIO_LOCAL_PERMISSIONS_DENIED";
export const TWILIO_LOCAL_MIC_TOGGLED = "TWILIO_LOCAL_MIC_TOGGLED";
export const TWILIO_LOCAL_CAMERA_TOGGLED = "TWILIO_LOCAL_CAMERA_TOGGLED";
export const TWILIO_LOCAL_DEVICE_REVOKED = "TWILIO_LOCAL_DEVICE_REVOKED";

// Network
export const TWILIO_NETWORK_QUALITY_CHANGED = "TWILIO_NETWORK_QUALITY_CHANGED";

// SDK errors
export const TWILIO_ERROR_SDK = "TWILIO_ERROR_SDK";
